import { render, staticRenderFns } from "./SecondTab.vue?vue&type=template&id=4461bf4a"
import script from "./SecondTab.vue?vue&type=script&lang=js"
export * from "./SecondTab.vue?vue&type=script&lang=js"
import style0 from "./SecondTab.vue?vue&type=style&index=0&id=4461bf4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports